import type { Jet } from '~/jet';
import type { LoggerFactory } from '@amp/web-apps-logger';
import type { LaunchNativeAppAction } from '~/jet/models';

import { launchApp } from '~/utils/launch-utils';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
};

/**
 * Handles urls that should launch one of the many apple native apps.
 */
export function registerHandler(dependencies: Dependencies) {
    const { jet, logger } = dependencies;

    const log = logger.loggerFor(
        'jet/action-handlers/launch-native-app-action',
    );

    jet.onAction(
        'launchNativeAppAction',
        async (action: LaunchNativeAppAction) => {
            log.info('received native app URL:', action);
            if (action?.url) {
                log.info(`launching native app for ${action.url}`);

                launchApp(action.url, action.appToOpen, log);
            } else {
                // TODO: what to show when native app launch fails? should we open a support page?
                log.warn(`failed to launch native app for ${action.url}`);
            }

            return 'performed';
        },
    );
}
